import { useTranslation } from 'react-i18next';
import { TouchableOpacity } from 'react-native';

import { ClearIcon } from '@/assets/icons/clearIcon';
import { Text } from '@/components/TextComponent';
import { Row } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';

import { useClearBetslip } from '../hooks/use-clear-betslip';

export const RemovePicksButton = () => {
    const { handleClearPress } = useClearBetslip();
    const { t } = useTranslation('betslip_sbk');
    return (
        <TouchableOpacity onPress={handleClearPress} hitSlop={12}>
            <Row alignItems="center" gap="s8">
                <Text variant="titleMedium" color={ds.colorToken.text.danger}>
                    {t('clear_all_picks')}
                </Text>
                <ClearIcon color={ds.colorValue.background.danger.strong} />
            </Row>
        </TouchableOpacity>
    );
};
